define.alias("shared/utils/is-popup-window", "preview-grid/utils/is-popup-window");